import { generateHeader } from '@/utilities/router/generate-header';

import type { RouteRecordRaw } from '@bv/router';

const businessChatRoutes: RouteRecordRaw = {
  path: 'business-chat',
  name: 'bc',
  meta: {
    header: generateHeader('Business chat'),
    breadcrumbs: [
      {
        label: 'Business chat',
        route: { name: 'bc' },
      },
    ],
  },
  component: () => import('@/views/ComingSoon.vue'),
};

export default businessChatRoutes;
